import RichTextEditor from './RichTextEditor';
import { getRTEDecorators } from './getDecorator';

export default RichTextEditor;
export { getRTEDecorators };
